import { Component, AfterViewChecked, ChangeDetectorRef, AfterViewInit, forwardRef } from "@angular/core";
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormBuilder } from "@angular/forms";
import { switchMap, filter } from "rxjs";

import { UsuariosRepository } from "@shared/Repositories/usuarios.repository";

import { RGVSISharedService } from "@RGVSI/Shared/Services/rgvsishared.service";

@Component({
  selector: "app-name-form",
  templateUrl: "./name-form.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NameFormComponent),
      multi: true,
    },
  ],
})
export class NameFormComponent implements ControlValueAccessor, AfterViewChecked, AfterViewInit {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private rgvsiSharedService: RGVSISharedService,
    private usuarioRepository: UsuariosRepository,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  public clientName = this.formBuilder.group({
    firstName: [],
    lastName: [],
  });

  public onTouched = (): void => {
    this.clientName.markAsTouched();
  };

  public ngAfterViewInit(): void {
    this.rgvsiSharedService.isPersonalClient
      .pipe(
        filter((isPersonalClient) => isPersonalClient === true),
        switchMap(() => this.usuarioRepository.getInfoClienteActual())
      )
      .subscribe((result) => {
        this.nameTypeControl.setValue(result?.nombres);
        this.lastNameTypeControl.setValue(result?.apellidos);
      });
  }

  public ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  public writeValue(value: Record<string, string>): void {
    if (value) {
      this.clientName.setValue(value, { emitEvent: true });
    }
  }

  public registerOnChange(fn: (value: Record<string, string>) => void): void {
    this.clientName.valueChanges.subscribe(fn);
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    isDisabled
      ? this.clientName.disable({ emitEvent: false, onlySelf: true })
      : this.clientName.enable({ emitEvent: false, onlySelf: true });
  }

  public get nameTypeControl(): AbstractControl {
    return this.clientName.get("firstName");
  }

  public get lastNameTypeControl(): AbstractControl {
    return this.clientName.get("lastName");
  }
}
